import React from 'react';
import { useTranslation } from 'react-i18next';
import { Cloud } from 'lucide-react';
import { Modal } from './Modal';
import { setUpgradeModalOpen, setUpgradeReason } from '../../store/uiModalStore';

/**
 * Web app: the plan's cloud is full, so this item cannot be created here.
 *
 * WHY THIS IS A STOP AND NOT A WARNING. On the desktop a new item past the
 * limit simply lands on the device (cloud/local items, card C5). The web app
 * has nowhere to put it — `records/web/webRecordsBackend` is online-only and
 * holds each scope in memory — so letting the user create one means the server
 * refuses it, the row sits on screen looking saved, and it is gone on the next
 * reload. Better to say so before they type.
 *
 * Two honest ways out, both offered: the desktop app, which can keep it on
 * their machine, or more room in the cloud.
 */
export default function CloudFullModal({ isOpen, kind, onClose }) {
  const { t } = useTranslation();
  if (!isOpen) return null;

  return (
    <Modal
      isOpen
      onClose={onClose}
      title={t('cloudFull.title')}
      customIcon={<Cloud size={18} />}
    >
      <div className="flex flex-col" style={{ gap: '0.875rem' }}>
        <p style={{ margin: 0, fontSize: 13, lineHeight: 1.55 }}>{t(`cloudFull.body.${kind}`)}</p>
        <div className="modal-footer-row">
          <button
            type="button"
            className="px-3 py-1.5 text-gray-600 bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors modern-button-secondary text-sm"
            onClick={onClose}
          >
            {t('cloudFull.close')}
          </button>
          <button
            type="button"
            className="px-3 py-1.5 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors modern-button text-sm"
            onClick={() => {
              setUpgradeReason(t('cloudFull.upgradeReason'));
              setUpgradeModalOpen(true);
              onClose?.();
            }}
          >
            {t('cloudFull.upgrade')}
          </button>
        </div>
      </div>
    </Modal>
  );
}
